"use client";
import { ViewportAnimatedImage as AnimatedOptimizedImage } from "@/components/shared/AnimatedOptimizedImage";
import Image from "next/image";
import React from "react";
import { useTranslation } from "react-i18next";
import HeadingSize from "../ui/HeadingSize";
const OptimizedImage = ({
  src,
  alt,
  width,
  height,
  className,
  preload = false,
}: {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  preload?: boolean;
}) => {
  const baseSrc = src.replace(/\.\w+$/, "");

  return (
    <picture>
      <source srcSet={`${baseSrc}.webp`} type="image/webp" />
      <source srcSet={`${baseSrc}.png`} type="image/png" />
      <Image
        src={`${baseSrc}.webp`}
        alt={alt}
        width={width}
        height={height}
        loading={preload ? "eager" : "lazy"}
        placeholder="blur"
        blurDataURL="/images/placeholder.png"
        className={className}
      />
    </picture>
  );
};

const QualityBarSection = () => {
  const { t } = useTranslation();
  return (
    <section className={"relative bg-white py-6 sm:py-16 md:pt-16 md:pb-1"}>
      {/* <div className="h-[160px] absolute -top-[350px] right-0 md:hidden">
        <AnimatedOptimizedImage
          src="/images/home/Ingredient/2nd.png"
          alt="Decorative dots graphic"
          width={160}
          height={160}
          className="object-contain w-[90px] h-[120px]"
        />
      </div> */}
      <div className="container px-0 m-0 max-w-[100%]">
        <div className="px-8   text-center mb-8 sm:mb-20 max-w-6xl mx-auto">
          <HeadingSize text={t("home.qualityBarHeading")} />
        </div>
        <div className="h-[160px]  absolute -top-[140px] -left-3 md:top-[0px] lg:top-[100px] xl:top-[0px] z-20">
          <AnimatedOptimizedImage
            src="/images/home/Ingredient/1st.png"
            alt="Decorative person graphic"
            width={160}
            height={300}
            className="object-contain w-[60px] h-[100px] md:h-[300px] md:w-[150px]"
          />
        </div>
        <div className=" mx-auto mb-8 sm:mb-16">
          <div className="grid grid-cols-2 md:grid-cols-2 relative">
            {/* Top Row */}
            <div className="flex flex-col items-center text-center relative z-10 py-6 px-12">
              <div className="text-2xl md:text-5xl lg:text-6xl font-bold text-[#ac000c] mb-2 md:mb-4">
                1
              </div>
              <p className="text-md text-[#000000] font-['Ainslie_Sans']  font-medium md:text-xl lg:text-[32px] lg:leading-[36px]">
                {t("home.trustStats.obsessivelyCuratedPart1")}
                <br />
                {t("home.trustStats.obsessivelyCuratedPart2")}
              </p>
            </div>

            <div className="flex flex-col items-center text-center relative z-10 py-6 px-12 border-t border-b border-l border-1 border-[#ff0000] rounded-tl-[80px] md:rounded-tl-[220px]">
              <div className="text-2xl md:text-5xl lg:text-6xl font-bold text-[#ac000c] mb-2 md:mb-4">
                30+
              </div>
              <p className="text-md text-[#000000] font-['Ainslie_Sans']  font-medium md:text-xl lg:text-[32px] lg:leading-[36px]">
                {t("home.trustStats.yearsOfResearchPart1")}
                <br />
                {t("home.trustStats.yearsOfResearchPart2")}
              </p>
            </div>

            {/* Bottom Row */}
            <div className="flex flex-col items-center text-center relative z-10 py-6 px-12 border-t border-b border-r border-1 border-[#ff0000] rounded-br-[80px] md:rounded-br-[220px]">
              <div className="text-2xl md:text-5xl lg:text-6xl font-bold text-[#ac000c] mb-2 md:mb-4">
                200+
              </div>
              <p className="text-md text-[#000000] font-['Ainslie_Sans']  font-medium md:text-xl lg:text-[32px]">
                {t("home.trustStats.grantedPatents")}
              </p>
            </div>

            <div className="flex flex-col items-center text-center relative z-10 py-6 px-12">
              <div className="text-2xl md:text-5xl lg:text-6xl font-bold text-[#ac000c] mb-2 md:mb-4">
                6
              </div>
              <p className="text-md text-[#000000] font-['Ainslie_Sans']  font-medium md:text-xl lg:text-[32px] lg:leading-[36px]">
                {t("home.trustStats.indianFlavoursPart1")}
                <br />
                {t("home.trustStats.indianFlavoursPart2")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QualityBarSection;
